export const CUSTOM_GROUPING = [
  {
    parent: "Somatik",
    value: "AIM"
  },
  {
    parent: "Legitimerad SSK",
    value: "Legitimerad SSK"
  },
  {
    parent: "Somatik",
    value: "Akutmottagning"
  },
  {
    parent: "Somatik",
    value: "Ambulanssjukvård"
  },
  {
    parent: "Somatik",
    value: "Anestesi"
  },
  {
    parent: "Somatik",
    value: "Astma/Kol"
  },
  {
    parent: "Somatik",
    value: "AVA"
  },
  {
    parent: "Somatik",
    value: "Barnakut"
  },
  {
    parent: "Somatik",
    value: "Barnkirurgi"
  },
  {
    parent: "Somatik",
    value: "Barnonkologi"
  },
  {
    parent: "Somatik",
    value: "BB"
  },
  {
    parent: "Somatik",
    value: "BIVA"
  },
  {
    parent: "Somatik",
    value: "BRIVA"
  },
  {
    parent: "Somatik",
    value: "Cytostatika"
  },
  {
    parent: "Somatik",
    value: "Dialys"
  },
  {
    parent: "Somatik",
    value: "Förlossning"
  },
  {
    parent: "Somatik",
    value: "Geriatrik"
  },
  {
    parent: "Somatik",
    value: "Gynekologi"
  },
  {
    parent: "Somatik",
    value: "Infektion"
  },
  {
    parent: "Somatik",
    value: "Internmedicin"
  },
  {
    parent: "Somatik",
    value: "IVA"
  },
  {
    parent: "Somatik",
    value: "Kardiologi/Hjärtavdelning"
  },
  {
    parent: "Somatik",
    value: "KAVA"
  },
  {
    parent: "Somatik",
    value: "Kirurgi"
  },
  {
    parent: "Somatik",
    value: "Lungmedicin"
  },
  {
    parent: "Somatik",
    value: "MIVA"
  },
  {
    parent: "Somatik",
    value: "Neonatal"
  },
  {
    parent: "Somatik",
    value: "Neuro"
  },
  {
    parent: "Somatik",
    value: "HIA"
  },
  {
    parent: "Somatik",
    value: "Hematologi"
  },
  {
    parent: "Somatik",
    value: "NIVA"
  },
  {
    parent: "Somatik",
    value: "Njurmedicin"
  },
  {
    parent: "Somatik",
    value: "Onkologi"
  },
  {
    parent: "Somatik",
    value: "Ortopedi"
  },
  {
    parent: "Somatik",
    value: "Plastik"
  },
  {
    parent: "Somatik",
    value: "Post-op"
  },
  {
    parent: "Somatik",
    value: "Rehabilitering"
  },
  {
    parent: "Somatik",
    value: "Stroke"
  },
  {
    parent: "Somatik",
    value: "THIVA"
  },
  {
    parent: "Somatik",
    value: "Thorax"
  },
  {
    parent: "Somatik",
    value: "Urologi"
  },
  {
    parent: "Somatik",
    value: "ÖNH"
  },
  {
    parent: "Primärvård",
    value: "Diabetes"
  },
  {
    parent: "Primärvård",
    value: "BVC"
  },
  {
    parent: "Primärvård",
    value: "Mödravårdscentral"
  },
  {
    parent: "Primärvård",
    value: "Företagshälsovård"
  },
  {
    parent: "Primärvård",
    value: "Mödravårdscentral"
  },
  {
    parent: "Primärvård",
    value: "1177"
  },
  {
    parent: "Primärvård",
    value: "Vaccinering"
  },
  {
    parent: "Primärvård",
    value: "Vårdcentral"
  },
  {
    parent: "Primärvård",
    value: "Digital vård"
  },
  {
    parent: "Ögon",
    value: "Kataraktoperationer"
  },
  {
    parent: "Ögon",
    value: "Ögonkirurgi (ej katarakt)"
  },
  {
    parent: "Ögon",
    value: "Ögonmottagning"
  },
  {
    parent: "Psykiatri",
    value: "Allmänpsykiatrisk avdelning"
  },
  {
    parent: "Psykiatri",
    value: "Beroendeavdelning"
  },
  {
    parent: "Psykiatri",
    value: "BVC"
  },
  {
    parent: "Psykiatri",
    value: "Kriminalvård"
  },
  {
    parent: "Psykiatri",
    value: "Missbruk"
  },
  {
    parent: "Psykiatri",
    value: "PIVA/Akutpsykiatrisk avdelning"
  },
  {
    parent: "Psykiatri",
    value: "Psykosavdelning"
  },
  {
    parent: "Psykiatri",
    value: "Rättspsykiatri"
  },
  {
    parent: "Psykiatri",
    value: "SIS LVM"
  },
  {
    parent: "Psykiatri",
    value: "SIS LVU"
  },
  {
    parent: "Psykiatri",
    value: "Slutenvård psykiatri"
  },
  {
    parent: "Psykiatri",
    value: "BUP"
  },
  {
    parent: "Psykiatri",
    value: "Äldrepsykiatrisk avdelning"
  },
  {
    parent: "Psykiatri",
    value: "Öppenvård psykiatri"
  },
  {
    parent: "Kommun",
    value: "ASIH"
  },
  {
    parent: "Kommun",
    value: "Chef"
  },
  {
    parent: "Kommun",
    value: "Hemsjukvård"
  },
  {
    parent: "Kommun",
    value: "Korttidsboende"
  },
  {
    parent: "Kommun",
    value: "LSS"
  },
  {
    parent: "Kommun",
    value: "Skolsköterska"
  },
  {
    parent: "Kommun",
    value: "Socialpsykiatri"
  },
  {
    parent: "Kommun",
    value: "SÄBO"
  },
  {
    parent: "Kommun",
    value: "ASIH"
  },
  {
    parent: "Kommun",
    value: "MAS"
  }
];
